import { z } from 'zod'

import { dbEntitySchema } from './system'

export const productAvailabilityGetByIdArgsSchema = z.object({
  venueId: z.string(),
  productId: z.string(),
  date: z.coerce.date(),
})

export const productAvailabilityCounterArgsSchema =
  productAvailabilityGetByIdArgsSchema.extend({
    quantity: z.number().int().min(1),
    quantityTotal: z.number().int().min(0),
  })

export const productAvailabilityGetByIdResultSchema =
  productAvailabilityGetByIdArgsSchema.extend({
    quantityTotal: z.number().int().min(0),
    quantityReserved: z.number().int().min(0),
    quantitySold: z.number().int().min(0),
    availableQuantity: z.number().int().min(0),
  })

export const productAvailabilityCounterSchema = dbEntitySchema.extend({
  venue: z.string(),
  product: z.string(),
  date: z.coerce.date(),
  quantityTotal: z.number().int().min(0),
  quantityReserved: z.number().int().min(0),
  quantitySold: z.number().int().min(0),
})
